export default {
  12: {
    register: 12,
    name: 'FRONT RIGHT LIGHTS',
    __type: 'Object',
    className: 'Equipment',
    id: 'BAsCYt7VBH'
  },
  2014: {
    name: 'AIR TEMP',
    register: 2014,
    unit: '°',
    formatter: 10,
    __type: 'Object',
    className: 'Sensor',
    id: 'SUnFkakR8E'
  },
  2016: {
    name: 'CO2',
    register: 2016,
    unit: 'ppm',
    formatter: 1,
    __type: 'Object',
    className: 'Sensor',
    id: '3vO5oA8qfy'
  }
}



// WEBPACK FOOTER //
// ./containers/Analyze/registerToDataSource.js